// Country code mapping utility
export interface CountryInfo {
  name: string;
  flag: string;
}

export const countryMapping: Record<string, CountryInfo> = {
  AD: { name: 'Andorra', flag: '🇦🇩' },
  AE: { name: 'United Arab Emirates', flag: '🇦🇪' },
  AT: { name: 'Austria', flag: '🇦🇹' },
  AU: { name: 'Australia', flag: '🇦🇺' },
  BE: { name: 'Belgium', flag: '🇧🇪' },
  BM: { name: 'Bermuda', flag: '🇧🇲' },
  CA: { name: 'Canada', flag: '🇨🇦' },
  CH: { name: 'Switzerland', flag: '🇨🇭' },
  CN: { name: 'China', flag: '🇨🇳' },
  CR: { name: 'Costa Rica', flag: '🇨🇷' },
  DE: { name: 'Germany', flag: '🇩🇪' },
  DK: { name: 'Denmark', flag: '🇩🇰' },
  ES: { name: 'Spain', flag: '🇪🇸' },
  FI: { name: 'Finland', flag: '🇫🇮' },
  FR: { name: 'France', flag: '🇫🇷' },
  GB: { name: 'United Kingdom', flag: '🇬🇧' },
  GG: { name: 'Guernsey', flag: '🇬🇬' },
  IE: { name: 'Ireland', flag: '🇮🇪' },
  IL: { name: 'Israel', flag: '🇮🇱' },
  IT: { name: 'Italy', flag: '🇮🇹' },
  JE: { name: 'Jersey', flag: '🇯🇪' },
  JP: { name: 'Japan', flag: '🇯🇵' },
  KY: { name: 'Cayman Islands', flag: '🇰🇾' },
  LU: { name: 'Luxembourg', flag: '🇱🇺' },
  NL: { name: 'Netherlands', flag: '🇳🇱' },
  NO: { name: 'Norway', flag: '🇳🇴' },
  SE: { name: 'Sweden', flag: '🇸🇪' },
  US: { name: 'United States', flag: '🇺🇸' },
  XC: { name: 'No Country Code', flag: '🏳️' },
};

export const getCountryInfo = (countryCode: string): CountryInfo => {
  return (
    countryMapping[countryCode.toUpperCase()] || {
      name: countryCode,
      flag: '🏳️',
    }
  );
};

export const formatCountryDisplay = (countryCode: string): string => {
  if (countryCode === 'Insgesamt') {
    return countryCode;
  }

  const info = getCountryInfo(countryCode);
  return `${info.flag} ${info.name}`;
};
